import { ReactElement } from "react";
import {
	Icon,
	IconButtonWithTitle
} from "client/Components";
import { MenuList } from "./MenuList";
import { localize } from "client_legacy/ndaw/culture";
import styles from "./SelectImageMenu.module.less";
import { generateTrackingId, isNil } from "client/Misc/utils";
import { HubImageSelectorKind } from "client/Features/Hub/Management/useHubImageSelector";

export type SelectImageMenuProps = {
	onSelectImage: (kind: HubImageSelectorKind) => void;
	trackingId: string;
	tabbableIndex?: number;
	isPixabayImageGalleryAvailable: boolean;
} & (
	| {
		onBack: () => void;
		title: string;
	}
	| {
		onBack?: undefined;
		title?: string;
	}
);

export const SelectImageMenu = (props: SelectImageMenuProps): ReactElement => {
	const {
		trackingId,
		onSelectImage,
		onBack,
		title,
		tabbableIndex,
		isPixabayImageGalleryAvailable
	} = props;

	const renderHeader = (): ReactElement | null => {
		if (isNil(title)) {
			return null;
		}

		if (onBack) {
			return (
				<div className={styles.backButton}>
					<IconButtonWithTitle
						title={title}
						icon="chevron-left"
						onClick={onBack}
						trackingId={generateTrackingId(trackingId, "__back-button")}
					/>
				</div>
			);
		}

		return (
			<h4 className={styles.title}>
				{title}
			</h4>
		);
	};

	return (
		<>
			{renderHeader()}
			<MenuList trackingId={trackingId}>
				<MenuList.Item
					image={<Icon value="folder-open" size="large"/>}
					title={localize("_Workspace")}
					trackingId="select-from-workspace"
					onClick={() => onSelectImage("workspace")}
					index={0}
					tabbableIndex={tabbableIndex}
				/>
				<MenuList.Item
					image={<Icon value="upload" size="large" />}
					title={localize("_Device")}
					trackingId="from-device"
					onClick={() => onSelectImage("device")}
					index={1}
					tabbableIndex={tabbableIndex}
				/>
				{isPixabayImageGalleryAvailable && (
					<MenuList.Item
						image={<Icon value="file-image" size="large" />}
						title={localize("_ImageLibraryPixabay")}
						trackingId="from-image-library"
						onClick={() => onSelectImage("pixabay")}
						index={2}
						tabbableIndex={tabbableIndex}
					/>
				)}
			</MenuList>
		</>
	);
};
SelectImageMenu.displayName = "SelectImageMenu";